export default __webpack_public_path__ + "static/media/9575EE61-A739-4F62-BBA0-685DC980384D_1_105_c.c738cb9f.jpeg";